import React         from 'react';
import PropTypes     from 'prop-types';
import {formatPrice,
	   isCurrencyVoucher} from '../dailyBonusHelpers';
import Flux          from '../../../flux/Flux.js';

const AlbumPriceLabel = (props) => {
	const {additionalClass, price, basePrice, discountedPrice = null, purchased} = props;

	const isVoucher = isCurrencyVoucher(price);
	if (price.value === 0) {
		return null;
	}

	const priceClass     = discountedPrice === null ? 'new' : 'old';
	const showDiscounted = !purchased && discountedPrice !== null && discountedPrice.value !== basePrice.value;

	return (
		Flux.Guest.isLoggedIn() && <div className={['dailybonus-badge', '--price', additionalClass].join(' ')}>
			<span className={priceClass}>{formatPrice(basePrice)}</span> &nbsp;
			{isVoucher && showDiscounted && (<span className='new'>{formatPrice(price, basePrice)}</span>)}
			{!isVoucher && showDiscounted && (<span className='new'>{formatPrice(discountedPrice)}</span>)}
		</div>
	);
};

const PriceTypeShape = PropTypes.shape({
	value:    PropTypes.number,
	currency: PropTypes.string,
});

AlbumPriceLabel.propTypes = {
	additionalClass: PropTypes.string,
	discountedPrice: PriceTypeShape,
	price:           PriceTypeShape.isRequired,
	basePrice:       PriceTypeShape,
	purchased:       PropTypes.bool,
};

AlbumPriceLabel.defaultProps = {
	additionalClass: '',
	discountedPrice: null,
	price:           {
		value: 0,
	},
	basePrice:           {
		value: 0,
	},
	purchased:       false,
};

export default AlbumPriceLabel;
